import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  ChartDataset,
  ChartOptions,
} from 'chart.js'
import { Doughnut } from 'react-chartjs-2'
import ChartDataLabels from 'chartjs-plugin-datalabels'

ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels)

interface Props {
  innerText?: string
  labels: string[]
  datasets: ChartDataset<'doughnut', number[]>[]
  options?: ChartOptions<'doughnut'>
}

export function DoughnutChart({ innerText, datasets, labels, options }: Props) {
  return (
    <Doughnut
      data={{
        labels,
        datasets,
      }}
      options={{
        responsive: true,
        cutout: '40%',
        plugins: {
          legend: {
            display: false,
            position: 'top',
          },
          datalabels: {
            display: true,
            color: '#ffe',
            font: {
              size: 18,
            },
            textStrokeWidth: 2,
            textStrokeColor: '#555',
            textShadowColor: '#555',
            formatter(
              value,
              {
                dataIndex,
                chart: {
                  data: { labels },
                },
              }
            ) {
              if(value === 0){
                return null
              }
              return (labels as any)[dataIndex] + '\n' + value + '%'
            },
          },
          tooltip: {
            callbacks: {
              label: ({ formattedValue, label }) => {
                return label + ': ' + formattedValue + '%'
              },
            },
          },
        },
        ...options,
      }}
      plugins={[
        {
          id: innerText + 'dn1',
          beforeDraw(chart) {
            if (!innerText) return
            const width = chart.width,
              height = chart.height,
              ctx = chart.ctx
            ctx.restore()
            const fontSize = (height / 160).toFixed(2)
            ctx.font = fontSize + 'em sans-serif'
            ctx.textBaseline = 'middle'
            const text = innerText,
              textX = Math.round((width - ctx.measureText(text).width) / 2),
              textY = height / 2
            ctx.fillText(text, textX, textY)
            ctx.save()
          },
        },
      ]}
    />
  )
}
